import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import { fsExcludeClass, isExcludedIdentifier } from '../../../../../utils/fsExclude'

const TooltipTitleCell = (props) => {
  const { column } = props
  const cn = isExcludedIdentifier(column.id) ? fsExcludeClass : undefined

  if (column?.tooltipTitle) {
    return (
      <Tooltip title={column.tooltipTitle}>
        <span className={cn}>{column.header}</span>
      </Tooltip>
    )
  }

  return <span className={cn}>{column.header}</span>
}

TooltipTitleCell.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.string,
    header: PropTypes.string,
    tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
}

export default TooltipTitleCell
